export class VideoThumbnailModel {
  videoFilename: string;
  videoThumbnailFilenameUrl: string;

  constructor(init: any) {    
    this.videoFilename = init.VideoFilename;
    this.videoThumbnailFilenameUrl = init.VideoThumbnailFilenameUrl;
  }
}
